import { createActions } from 'reduxsauce';

const { Types: types, Creators: actions } = createActions({
    // add unit
    requestSubmitUnit: ['id', 'data'],
    submitUnitSucceeded: ['data'],
    submitUnitFailed: ['errors'],

    // clear state
    clearUnitCreateState: null,
});

export default {
    // add unit
    [types.REQUEST_SUBMIT_UNIT]: (state) => ({
        ...state,
        create: {
            ...state.create,
            submitting: true,
            errors: null,
        },
    }),
    [types.SUBMIT_UNIT_SUCCEEDED]: (state, { data }) => ({
        ...state,
        create: {
            ...state.create,
            submitting: false,
            unitDetails: data,
            success: true,
        },
    }),
    [types.SUBMIT_UNIT_FAILED]: (state, { errors }) => ({
        ...state,
        create: {
            ...state.create,
            submitting: false,
            success: false,
            errors,
        },
    }),

    // clear state
    [types.CLEAR_UNIT_CREATE_STATE]: (state) => ({
        ...state,
        create: {
            ...state.create,
            unitDetails: null,
            success: false,
            errors: null,
        },
    }),
};

export { types, actions };